import { render, staticRenderFns } from "./ComprasDiretasEncerradas.vue?vue&type=template&id=4e2af200&scoped=true"
import script from "./ComprasDiretasEncerradas.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasEncerradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2af200",
  null
  
)

export default component.exports